"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationAssignment = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TemplatesSelector_1 = require("Common/Templates/TemplatesSelector");
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var AutomationAssignment = function (_a) {
    var associations = _a.associations, onAssociationsChange = _a.onAssociationsChange, supportedTemplates = _a.supportedTemplates, errorMessage = _a.errorMessage, errorIds = _a.errorIds;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var setSelectedTemplates = function (selectedTemplateIds) {
        onAssociationsChange(selectedTemplateIds.map(function (templateId) {
            return { resourceType: "template", resourceId: templateId };
        }));
    };
    return usingFeature(FeatureFlag_1.FeatureFlag.HubspotSyncEssentialsAssignmentUX) ? (react_1.default.createElement(kaleidoscope_1.Stack, null,
        react_1.default.createElement(kaleidoscope_1.Card, null,
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", gap: "s" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal" },
                    react_1.default.createElement(kaleidoscope_1.Stack, null,
                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, "Assign automation"),
                        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" },
                            "Choose which templates you want to assign this automation. You can also assign automations later from the",
                            " ",
                            react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/templates", target: "_blank" }, "templates dashboard.")))),
                react_1.default.createElement(kaleidoscope_1.Stack, null,
                    react_1.default.createElement(TemplatesSelector_1.TemplatesSelector, { selectedTemplates: associations === null || associations === void 0 ? void 0 : associations.map(function (association) { return association.resourceId; }), setSelectedTemplates: setSelectedTemplates, templatesFilter: { withCrmInfo: supportedTemplates }, errorMessage: errorMessage, errorIds: errorIds })))))) : null;
};
exports.AutomationAssignment = AutomationAssignment;
